var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/import"
  }, /*#__PURE__*/React.createElement("g", {
    id: "import"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.12988 1V9.43023L6.84977 8.15012C6.55977 7.86012 6.07977 7.86012 5.78977 8.15012C5.49977 8.44012 5.49977 8.92012 5.78977 9.21012L8.34977 11.7701C8.49977 11.9201 8.68977 11.9901 8.87977 11.9901C9.06977 11.9901 9.25977 11.9201 9.40977 11.7701L11.9698 9.21012C12.2598 8.92012 12.2598 8.44012 11.9698 8.15012C11.6798 7.86012 11.1998 7.86012 10.9098 8.15012L9.62988 9.43V1C9.62988 0.59 9.28988 0.25 8.87988 0.25C8.46988 0.25 8.12988 0.59 8.12988 1Z",
    fill: "#1B75BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.25 9.17993C0.25 14.3299 3.85 17.9299 9 17.9299C14.15 17.9299 17.75 14.3299 17.75 9.17993C17.75 8.76993 17.41 8.42993 17 8.42993C16.59 8.42993 16.25 8.76993 16.25 9.17993C16.25 13.4499 13.27 16.4299 9 16.4299C4.73 16.4299 1.75 13.4499 1.75 9.17993C1.75 8.76993 1.41 8.42993 1 8.42993C0.59 8.42993 0.25 8.76993 0.25 9.17993Z",
    fill: "#1B75BC"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.df5279ef737aacb3db65dafe56a16881.svg";
export { ForwardRef as ReactComponent };